export const substituteLabel = (name, isActive) => (isActive ? name : `${name} (неактивна)`);
